import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

export const CLOSE_SOURCES = {
  BACKDROP: 1,
  CLOSE_BUTTON: 2,
  ESCAPE: 3,
  ITEM_CLICK: 4,
};

export default (decoratorConfig = {}) => Component =>
  class ComponentAsModal extends React.Component {
    static displayName = `Modal(${Component.displayName || Component.name})`;

    static propTypes = {
      modalConfig: PropTypes.shape({
        backdropClass: PropTypes.string,
        centerHorizontally: PropTypes.bool,
        headerClass: PropTypes.string,
        hideClose: PropTypes.bool,
        hideScrollbar: PropTypes.bool,
        isPersistent: PropTypes.bool,
        lightClose: PropTypes.bool,
        modalBorderClass: PropTypes.string,
        modalContentClass: PropTypes.string,
        modalDialogClass: PropTypes.string,
      }),
      onModalClose: PropTypes.func,
    };

    constructor() {
      super();
      this.state = {
        belowOverlay: false,
      };
      this.handleToggleHide = this.handleToggleHide.bind(this);
      this.handleAllClicks = this.handleAllClicks.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleBackdropClick = this.handleBackdropClick.bind(this);
    }

    componentDidMount() {
      if (__CLIENT__ || __TEST__) {
        this.escListener = this.handleEscKeypress.bind(this);
        document.addEventListener('keydown', this.escListener);
      }
    }

    componentWillUnmount() {
      if ((__CLIENT__ || __TEST__) && this.escListener) {
        document.removeEventListener('keydown', this.escListener);
      }
    }

    handleBackdropClick() {
      const { onModalClose } = this.props;

      if (onModalClose) {
        onModalClose(CLOSE_SOURCES.BACKDROP);
      }
    }

    handleCloseClick() {
      const { onModalClose } = this.props;

      if (onModalClose) {
        onModalClose(CLOSE_SOURCES.CLOSE_BUTTON);
      }
    }

    handleEscKeypress(event) {
      const { onModalClose } = this.props;

      if (event.keyCode === 27) {
        if (onModalClose && !decoratorConfig.isPersistent) {
          onModalClose(CLOSE_SOURCES.ESCAPE);
        }
      }
    }

    handleAllClicks(event) {
      const { onModalClose } = this.props;

      if (event && event.target) {
        let { target } = event;

        while (target) {
          if (target.classList && target.classList.contains('modal__closer')) {
            if (onModalClose) {
              onModalClose(CLOSE_SOURCES.ITEM_CLICK);
            }
            return;
          }
          target = target.parentNode;
        }
      }
    }

    handleToggleHide(val = true) {
      this.setState({ belowOverlay: val });
    }

    render() {
      const { modalConfig } = this.props;
      const config = { ...decoratorConfig, ...modalConfig };

      return (
        <div onClick={!config.isPersistent ? this.handleAllClicks : undefined}>
          <div
            className={classNames('modal', config.headerClass, {
              'modal--no-scrollbar': config.hideScrollbar,
              'modal--below-overlay': this.state.belowOverlay,
              'modal--center-horizontally': config.centerHorizontally,
              'modal--center-vertically': config.centerVertically,
            })}
            data-qa="Modal">
            <div
              className={classNames('modal__dialog', config.modalDialogClass, {
                'modal__dialog--center-horizontally': config.centerHorizontally,
              })}>
              {!config.isPersistent && !config.hideClose && (
                <a
                  className={classNames('modal__close m', {
                    'modal__close--light': config.lightClose,
                  })}
                  data-qa="Modal.close"
                  onClick={!config.isPersistent ? this.handleCloseClick : undefined}>
                  Close
                </a>
              )}
              <div className={classNames('modal__border', config.modalBorderClass)}>
                <div className={classNames('modal__content', config.modalContentClass)}>
                  <Component {...this.props} onToggleHide={this.handleToggleHide} />
                </div>
              </div>
            </div>
          </div>

          <div
            className={classNames('modal__backdrop', config.backdropClass)}
            onClick={!config.isPersistent ? this.handleBackdropClick : undefined}
          />
        </div>
      );
    }
  };
